import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";
import { FeatureGate } from "@/features/billing/components/feature-gate";

const TeamView = lazy(async () => {
  const m = await import("@/features/workforce/components/team-view");
  return { default: m.TeamView };
});

export const teamRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/team",
  // MONETIZATION_QUOTAS (B2B): team reports are a tier feature
  // (`team_reports`). With monetization OFF (the default), the gate is inert.
  component: () => (
    <Suspense fallback={null}>
      <FeatureGate feature="team_reports">
        <TeamView />
      </FeatureGate>
    </Suspense>
  ),
});
